import type { ComponentType } from "react";
import PaymentMethodsProvider from "./PaymentMethodsProvider";

export const withPaymentMethods = <TProps extends object>(Component: ComponentType) =>
    (props: TProps) => (
        <PaymentMethodsProvider>
            <Component {...props} />
        </PaymentMethodsProvider>
    );

export default withPaymentMethods;
